/** @file checkTilePx: the field check of `tilePx` in a profile and in a puppet's profile overrides (22.1). */
import { checkHinted } from '@zilo/pose3d-format/validate/fields/checkHinted';
import { checkTuple } from '@zilo/pose3d-format/validate/fields/checkTuple';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** `[across, depth, height]`: three positive authored pixels per unit; a failure carries a hint naming the range. */
export const checkTilePx: FieldCheck = checkHinted(checkTuple(3, { above: 0 }),
  'tilePx is [across, depth, height]: three positive pixels per unit (a 24 x 16 tile = [24, 16, 16]); absent = pixelsPerUnit on every axis (22.1)');
